// extracted by mini-css-extract-plugin
module.exports = {"slider":"RangeSlider_slider__rVkJ7","valueLabel":"RangeSlider_valueLabel__iYm6n","labelContainer":"RangeSlider_labelContainer__TU8qI"};